module.exports = __webpack_public_path__ + "static/lotte-9905428b8a9c8ce6a3489dffcdc7f0a2.jpg";